VariationsWidget = window.VariationsWidget ?= {}
VariationsWidget.Models ?= {}

VariationsWidget.Models.Option = Backbone.Model.extend
  initialize: ->


module.exports = VariationsWidget.Models.Option



// WEBPACK FOOTER //
// ./modules/variations/frontend/models/option.coffee